import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SearchSection from './components/SearchSection';
import FeaturedSection from './components/FeaturedSection';
import ListingsSection from './components/ListingsSection';
import AboutSection from './components/AboutSection';
import BlogSection from './components/BlogSection';
import AreasSection from './components/AreasSection';
import { useSEO } from '../../utils/seo';

export default function Home() {
  useSEO({
    title: 'Jeffery Long - Best Realtor in California | eXp Realty Northern California | CA DRE #02234432',
    description: 'Jeffery Long - 40+ Years Real Estate Experience. Best Realtor in California for Commercial & Residential Properties. Serving Northern California, Sacramento, El Dorado Hills, Cameron Park. Expert in buying, selling, investment properties. CA DRE #02234432',
    keywords: 'best realtor California, Jeffery Long, eXp Realty, Northern California real estate, Sacramento realtor, commercial real estate, residential real estate, property sales, El Dorado Hills, Cameron Park, real estate agent, home buying, home selling',
    canonical: '/',
    ogTitle: 'Jeffery Long - Best Realtor in California | eXp Realty Northern California',
    ogDescription: '40+ Years in Real Estate. Expert Commercial & Residential Realtor serving Northern California, Sacramento, El Dorado Hills. Let my team support your journey.',
    ogImage: 'https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1727374637.png',
    ogType: 'website',
    schema: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Jeffery Long - eXp Realty Northern California",
      "url": "SITE_URL/",
      "description": "Jeffery Long - 40+ Years Real Estate Experience. Best Realtor in California for Commercial & Residential Properties. Serving Northern California, Sacramento, El Dorado Hills, Cameron Park.",
      "publisher": {
        "@type": "RealEstateAgent",
        "name": "Jeffery Long - eXp Realty of Northern California",
        "telephone": "+1-916-257-8244",
        "email": "realestatedevelopmentauthority@gmail.com",
        "url": "SITE_URL/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1727374637.png"
        },
        "sameAs": [
          "https://www.facebook.com/profile.php",
          "https://www.twitter.com/JeffL_eXpRealty",
          "https://www.linkedin.com/in/jeffery-long-355a73352/",
          "https://www.youtube.com/@realestatedevelopmentautho3005",
          "https://www.instagram.com/jeffery_long_exp_realty0223443/"
        ]
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": "SITE_URL/?s={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    },
  });

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        <HeroSection />
        <SearchSection />
        <FeaturedSection />
        <ListingsSection />
        <AboutSection />
        <BlogSection />
        <AreasSection />
      </main>
      <Footer />
    </div>
  );
}
